import { render, staticRenderFns } from "./NewTagDialog.vue?vue&type=template&id=9b765e36&"
import script from "./NewTagDialog.vue?vue&type=script&lang=js&"
export * from "./NewTagDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports